// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";

import AiPlaygroundController from "./ai_playground_controller";
application.register("ai-playground", AiPlaygroundController);

import AiSetupController from "./ai_setup_controller";
application.register("ai-setup", AiSetupController);

import BusinessAssistantController from "./business_assistant_controller";
application.register("business-assistant", BusinessAssistantController);

import BookingModalController from "./booking_modal_controller";
application.register("booking-modal", BookingModalController);

import AutoDismissController from "./auto_dismiss_controller";
application.register("auto-dismiss", AutoDismissController);

import BannerPreviewController from "./banner_preview_controller";
application.register("banner-preview", BannerPreviewController);

import BulkSelectionController from "./bulk_selection_controller";
application.register("bulk-selection", BulkSelectionController);

import CalendarController from "./calendar_controller";
application.register("calendar", CalendarController);

import CampaignFormController from "./campaign_form_controller";
application.register("campaign-form", CampaignFormController);

import EarthworkBulkController from "./earthwork_bulk_controller";
application.register("earthwork-bulk", EarthworkBulkController);

import FrameRefreshController from "./frame_refresh_controller";
application.register("frame-refresh", FrameRefreshController);

import ImagePreviewController from "./image_preview_controller";
application.register("image-preview", ImagePreviewController);

import PasswordVisibilityController from "./password_visibility_controller";
application.register("password-visibility", PasswordVisibilityController);

import PartnerFormController from "./partner_form_controller";
application.register("partner-form", PartnerFormController);

import ProjectFormController from "./project_form_controller";
application.register("project-form", ProjectFormController);

import ThemeController from "./theme_controller";
application.register("theme", ThemeController);

import TimeSlotBulkController from "./time_slot_bulk_controller";
application.register("time-slot-bulk", TimeSlotBulkController);

import WorkLogReviewController from "./work_log_review_controller";
application.register("work-log-review", WorkLogReviewController);

import WorkLogFormController from "./work_log_form_controller";
application.register("work-log-form", WorkLogFormController);

import NestedFieldsController from "./nested_fields_controller";
application.register("nested-fields", NestedFieldsController);

import ClipboardController from "./clipboard_controller";
application.register("clipboard", ClipboardController);

import MeetSpotAiController from "./meet_spot_ai_controller";
application.register("meet-spot-ai", MeetSpotAiController);
